export default {
  namespaced: true,
  helpdesk: {
    title: "Helpdesk",
    agent:{
      title: "Agent",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      is_active: "Is Active",
    },
    group:{
      title: "Conjunto",
      name: "Nome",
      description: "Descrição",
      is_active: "Ativo",
    },
    ticket:{
      title: "Ticket",
      create_ticket: "Criar ingresso",
      created_at: "Data de criação",
      name: "Nome",
      from: "De",
      subject: "Subject",
      message: "Mensagem",
      description: "Descrição",
      priority: "Prioridade",
      status: "Status",
      attachments: "Arquivos adjuntos",
      update: "Atualizar",
      cc: "CC",
      for: "Para",
      owner: 'Propietario',
      type: 'Tipo',
      ticket_type: 'Ticket tipo',
    }
  }
};
